<div class="wrapper">
  <div class="heading text-type-2 mb-[40px]">
    Add equipment
  </div>
  <form>
    <app-dropdown
      (addNewClicked)="openAddContractorDialog()"
      (checkForErrors)="checkForErrors($event)"
      [enableAddNew]="true"
      [enableSearch]="subContractorOptions.length >= 10"
      [error]="errorMessages['sub_contractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="sub_contractor"
      label="Contractor"
    />
    @if (form.controls['sub_contractor']?.value) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [options]="equipmentTypeOptions"
        [parentFormGroup]="form"
        [error]="errorMessages['equipment_type']"
        [sentenceCase]="true"
        class="mb-[20px]"
        controlName="equipment_type"
        label="Generic vendor equipment"
      />
    }
    @if (form.controls['equipment_type']?.value === 'vendor_equipment') {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [enableSearch]="true"
        [showCount]="true"
        [error]="errorMessages['equipments']"
        [options]="equipmentOptions"
        [parentFormGroup]="form"
        class="mb-[20px]"
        controlName="equipments"
        label="Select vendor equipment"
        selectionString="selected"
      />
      @for (eq of selectedEquipments; track eq) {
        <div class="entry-accordion mb-[12px]">
          <div
            (click)="toggleAccordion(eq)"
            class="entry-header"
          >
            <div class="entry-heading text-type-13">{{ eq.label | sentenceCase }}</div>
            <mat-icon class="chevron-icon" [class.is-expanded]="expandedEquipments[eq.value]">expand_more</mat-icon>
          </div>
          @if (expandedEquipments[eq.value]) {
            <div class="entry-content">
              <div class="flex flex-row gap-[20px] w-full mb-[20px]">
                <app-number-input
                  [parentFormGroup]="equipmentForms[eq.value]"
                  class="w-1/2"
                  controlName="quantity"
                  label="Quantity"
                />
                <app-number-input
                  [parentFormGroup]="equipmentForms[eq.value]"
                  class="w-1/2"
                  controlName="hours"
                  [isDecimalAllowed]="true"
                  label="Hours"
                />
              </div>
              <app-text-area
                [parentFormGroup]="equipmentForms[eq.value]"
                class="mb-[20px]"
                controlName="comment"
                label="Comment"
              />
            </div>
          }
        </div>
      }
    }
    @if (form.controls['equipment_type']?.value === 'generic_equipment') {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [enableSearch]="true"
        [showCount]="true"
        [error]="errorMessages['generic_equipments']"
        [options]="genericEquipmentOptions"
        [parentFormGroup]="form"
        class="mb-[20px]"
        controlName="generic_equipments"
        label="Select generic equipment"
        selectionString="selected"
      />
      @for (ge of selectedGenericEquipments; track ge) {
        <div class="entry-accordion mb-[12px]">
          <div
            (click)="toggleGenericEquipmentAccordion(ge)"
            class="entry-header"
          >
            <div class="entry-heading text-type-13">{{ ge.label | sentenceCase }}</div>
            <mat-icon class="chevron-icon" [class.is-expanded]="expandedGenericEquipments[ge.value]">expand_more</mat-icon>
          </div>
          @if (expandedGenericEquipments[ge.value]) {
            <div class="entry-content">
              <div class="flex flex-row gap-[20px] w-full mb-[20px]">
                <app-number-input
                  [parentFormGroup]="genericEquipmentForms[ge.value]"
                  class="w-1/2"
                  controlName="quantity"
                  label="Quantity"
                />
                <app-number-input
                  [parentFormGroup]="genericEquipmentForms[ge.value]"
                  class="w-1/2"
                  controlName="hours"
                  [isDecimalAllowed]="true"
                  label="Hours"
                />
              </div>
              <app-text-area
                [parentFormGroup]="genericEquipmentForms[ge.value]"
                class="mb-[20px]"
                controlName="comment"
                label="Comment"
              />
            </div>
          }
        </div>
      }
    }
  </form>
</div>
